import { formatarAteDuasCasas, interpretarNumero } from '@/lib/formato';

import type { ConversaoDaApi } from './api';

/**
 * A CONVERSÃO DE UNIDADE do item (migração 0088), no que a tela precisa dela.
 *
 * O item tem uma unidade; a compra e o uso podem vir em outra — a caixa com
 * 12, o balde de 20 L. A conta que vale é a do BANCO (gatilho
 * `converter_unidade`): a tela só mostra, antes de gravar, quanto a embalagem
 * vira na unidade do item, com o mesmo arredondamento (três casas).
 */

/** Quanto `quantidade` embalagens viram na unidade do item. */
export function quantoViraNoItem(quantidade: number, fator: number): number {
  return Math.round(quantidade * fator * 1000) / 1000;
}

/** "CX 12 = 12 un": a embalagem e o que ela tem, na unidade do item. */
export function textoDaConversao(c: Pick<ConversaoDaApi, 'unidade' | 'fator'>, unidadeDoItem: string): string {
  return `${c.unidade} = ${formatarAteDuasCasas(c.fator)} ${unidadeDoItem}`;
}

/** "2 CX 12 = 24 un no saldo." — a ajuda do campo de quantidade, quando há embalagem escolhida. */
export function ajudaDaConversao(quantidade: number | null, c: Pick<ConversaoDaApi, 'unidade' | 'fator'>, unidadeDoItem: string): string {
  if (quantidade === null || quantidade <= 0) return `Cada ${c.unidade} tem ${formatarAteDuasCasas(c.fator)} ${unidadeDoItem}; o saldo fica em ${unidadeDoItem}.`;
  return `${formatarAteDuasCasas(quantidade)} ${c.unidade} = ${formatarAteDuasCasas(quantoViraNoItem(quantidade, c.fator))} ${unidadeDoItem} no saldo.`;
}

/** O erro do fator digitado, dizendo o que fazer; `null` quando serve. */
export function erroDoFator(texto: string, unidadeDoItem: string): string | null {
  const n = interpretarNumero(texto);
  if (n === null || n <= 0) return `Informe quantas ${unidadeDoItem || 'unidades do item'} cabem na embalagem, como 12.`;
  return null;
}

/** O erro do nome da embalagem; `null` quando serve. */
export function erroDaEmbalagem(texto: string, unidadeDoItem: string): string | null {
  const t = texto.trim();
  if (t === '') return 'Diga o nome da embalagem, como CX 12 ou BALDE 20 L.';
  if (t.length > 40) return 'Use um nome curto para a embalagem, até 40 caracteres.';
  if (t.toLocaleUpperCase('pt-BR') === unidadeDoItem.toLocaleUpperCase('pt-BR')) return 'É a própria unidade do item. Dê o nome da embalagem em que ele chega.';
  return null;
}
